import { z } from "zod";

import { ScreenshotRecommendationSchema } from "../../schemas/ai";

export const ScreenshotRecommendationHistoryDtoSchema = z.object({
  id: z.string().uuid(),
  group: z.string(),
  dateTime: z.number(),
  screenshotUrl: z.string(),
  recommendations: ScreenshotRecommendationSchema.array(),
});

export type ScreenshotRecommendationHistoryDto = z.infer<
  typeof ScreenshotRecommendationHistoryDtoSchema
>;
